import React from "react";
import { FiChevronRight } from "react-icons/fi";
import {
  Headline,
  SectionContent,
  WidgetCard,
  WidgetCardsContainer,
} from "../../../../components";
import { applyKey } from "../../../../utils";
import * as S from "./CondicoesGerais.Style";

const CondicoesGeraisCards = () => {
  return (
    <SectionContent>
      <S.CondicoesGeraisCardContainer as={WidgetCardsContainer}>
        {applyKey(
          [
            {
              title: "Seguro Residencial",
              path: "/paravoce/residencial/condicoes-gerais/seguro-residencial",
            },
            {
              title: "Seguro Fácil Residencial",
              path:
                "/paravoce/residencial/condicoes-gerais/seguro-facil-residencial",
            },
            {
              title: "Apólice de Seguro Compreensivo de Imóveis",
              path:
                "/paravoce/residencial/condicoes-gerais/seguro-compreensivo-de-imoveis",
            },
          ],
          ({ title: cardTitle, path }) => (
            <S.CondicoesGeraisCard
              as={WidgetCard}
              header={
                <Headline as="3" styleAs="8">
                  {cardTitle}
                </Headline>
              }
            >
              <S.NavigationLinkItemStyled href={path}>
                <S.NavigationCardItemStyled>
                  <S.BodyLabelLink
                    textType="button"
                    reset={{ marginBottom: "0px" }}
                  >
                    Conferir agora
                  </S.BodyLabelLink>
                  <FiChevronRight />
                </S.NavigationCardItemStyled>
              </S.NavigationLinkItemStyled>
            </S.CondicoesGeraisCard>
          )
        )}
      </S.CondicoesGeraisCardContainer>
    </SectionContent>
  );
};

export default CondicoesGeraisCards;
